<template lang="pug">
  .cuadro-container
    loading(v-if="isLoading")
    info-card(
      v-if="!isLoading"
      :title="o.titulo"
      :number="o.cantidad"
      :iconClass="o.iconClass"
    )
</template>

<script>
import { apiGet } from '../../util/general';
import InfoCard from '../charts/c_info_card';

export default {
  name: 'cantidad_permisos_sin_aprobar_rrhh',
  components: {
    'info-card': InfoCard
  },
  data () {
    return {
      o: {
        cantidad:'',
        titulo: 'Boletas sin visualizar',
        iconClass:'fa-money'
      },
      isLoading: true
    };
  },
  created () {
    this.fetch();
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/kpi/cantidad-boletas-sin-visualizar', {}, function (data) {
        if (data.cantidad === 0) {
          vm.$emit('close')
          return
        }
        vm.o.cantidad = data.cantidad
      }, function (error) {
        console.error('error', error)
      }, function () {
        vm.isLoading = false
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// c_kpi_cantidad_boletas_sin_visualizar.vue?2934f3aa